// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"cf843240","155":"7d437a2a","223":"7068fa18","453":"277eacaa","953":"2e4f4001","995":"23b9e291"}[chunkId] + ".chunk.js";
};